import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function DeleteButton({ onConfirm, label = "this entry", testId, variant = "icon" }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  async function confirm(e) {
    e.preventDefault();
    setLoading(true);
    try { await onConfirm(); setOpen(false); } finally { setLoading(false); }
  }

  if (user?.role !== "admin") return null;

  return (
    <>
      {variant === "icon" ? (
        <Button size="icon" variant="ghost" data-testid={testId} onClick={() => setOpen(true)}
          className="h-8 w-8 text-destructive hover:bg-destructive/10 hover:text-destructive">
          <Trash2 className="h-4 w-4" />
        </Button>
      ) : (
        <Button size="sm" variant="ghost" data-testid={testId} onClick={() => setOpen(true)}
          className="rounded-full text-destructive hover:bg-destructive/10 hover:text-destructive">
          <Trash2 className="mr-1 h-3 w-3" /> Delete
        </Button>
      )}
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete {label}?</AlertDialogTitle>
            <AlertDialogDescription>This permanently removes it and cannot be undone.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={confirm} disabled={loading} data-testid={testId ? `${testId}-confirm` : undefined}
              className="bg-destructive hover:bg-destructive/90">{loading ? "Deleting..." : "Delete"}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
